import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../containers/header';
import Footer from '../containers/footer';
import Sidebar from '../components/Sidebar';
import Card from '../components/Card';
import { connect } from 'react-redux';
import * as actions from '../store/actions/auth';
 
class FirstPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            cards : [{title: 'How it works'},
            {title: 'About Us', content:'Nothing to see here, yet.' }
             ] 
        };
         
    }
    handleClick = (event) => {
        const linkclick = document.querySelectorAll('.click');
        for (let item of Array.from(linkclick)) {
        if (item  === event.target) {
        item.parentElement.style.background = '#1b9bff';
        }
        else{
          item.parentElement.style.background = 'white';
        }
      } 
      }; 
      
    render() {
        return (
            <div className='body'>
         <Header change={this.handleClick} >
         <ul className='navigation' onClick= {this.handleClick} >
              <li><Link to='/' className='click' >Home</Link></li>
              {this.props.authenticated ?
              <li><Link to='/HistoryList/' className='click' >Get Started</Link></li> :
              <li><Link to='/login/' className='click' >Get Started</Link></li>
            } 
              <li><a className='click' href='#I-don-tire'>How it works</a></li>
              {this.props.authenticated ?
              <li><button id='logout' onClick={this.props.logout} className='logout-click' >Logout</button></li> :
              <li><Link to='/login/' className='click' >Login</Link></li>
            }
            </ul>
             </Header>
         
         <Sidebar height={"100vh"} width ={300}>
         <ul className='not-navigation' onClick= {this.handleClick} >
         <li><Link to='/' className='click' >Home</Link></li>
         {this.props.authenticated ?
              <li><Link to='/HistoryList/' className='click' >Get Started</Link></li> :
              <li><Link to='/login/' className='click' >Get Started</Link></li>
            }
              <li><a className='click' href='#I-don-tire'>How it works</a></li>
              {this.props.authenticated ?
              <li><button id='logout' onClick={this.props.logout} className='logout-click' >Logout</button></li> :
              <li><Link to='/login/' className='click' >Login</Link></li>
            }
            </ul> 
          </Sidebar>
         <div className='page-content'>
         <div className='banner-area' id='home'> 
        <div id='I-don-tire' className='get-started-area'> <Card  title = {this.state.cards[0].title} content = {<ul className='specialList'>
        <li>The application only works for papers written with the APA format.</li>
          <li>Before you start please note that the website works best with microsoft word documents(.docx), the document view is very clean, generating result is much faster than pdf and the result is more accurate. I added pdf and txt for cross compatibility.</li>
         <li>Click get started to literally get started.</li>
         <li>If you are not logged in, the webpage will be redirected to the login page. Login or create an account(signup) to access the website.</li>
         <li>Upload a new document, writing a description is optional.</li>
         <li>After uploading you can view the results by clicking on the title of the document you just uploaded directly under 'Your History'.</li>  
         <li>You can choose the result you want to see on the Sidebar. SideNOTE: pdf document view is terrible, but it wasn't scrapped because I wrote like 10 lines of code for it.</li>   
         <li>Enjoy.</li>     
            </ul>}/>
            </div>
         </div>
         
        
        <div className='how-it-works-area' id='get-started-area'><Card title = {this.state.cards[1].title} content = {<p>{this.state.cards[1].content}</p>}/></div>
        
         </div>
       <Footer/>
        </div>

)
    };    
}    

const mapDispatchToProps = dispatch => {
  return {
      logout: () => dispatch(actions.confirmLogout()) 
  }
}
export default connect(null, mapDispatchToProps)(FirstPage);